var _defs, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sun",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.32,15.08s.5.02.77.13c.59.24,1.56,1,2.38,1.04s2.4-1.11,3.25-1.17,2.3,1.1,3.18,1.13c.82.03,2.55-1.05,3.36-1.12.94-.09,2.36,1.11,3.3,1.11.8,0,1.82-.78,2.39-1,.38-.15.72-.15.72-.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.03,19.3c.5.1.97.03,1.5-.17.73-.33,1.47-.93,2.34-.87,1,.13,1.73.8,2.67,1,1.07.27,1.87-.47,2.8-.87.73-.33,1.53-.13,2.2.2.8.33,1.43.77,2.4.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.77,13.27c-.1-2.39,1.1-3.61,2.25-4.22,1.27-.68,2.8-.76,4.07-.09,1.1.58,2.23,1.81,2.33,4.38"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.82,
    y1: 12.65,
    x2: 5.97,
    y2: 12.65
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.05,
    y1: 8.62,
    x2: 6.9,
    y2: 9.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.1,
    y1: 5.73,
    x2: 9.19,
    y2: 7.59
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.33,
    y1: 12.65,
    x2: 18.18,
    y2: 12.65
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.11,
    y1: 8.62,
    x2: 17.25,
    y2: 9.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.05,
    y1: 5.73,
    x2: 14.97,
    y2: 7.59
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.09,
    y1: 4.66,
    x2: 12.09,
    y2: 6.81
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.c6dfabbd93fa7a9a7877dd160b0447d3.svg";
export { ForwardRef as ReactComponent };